import React from 'react';
import { useFetch } from '../../../hooks/useFetch';
import Category from './Category';

function Categories() {
  const c = useFetch('https://www.fabrilum.com.ar/backend/getAplicaciones.php');

  return (
    <section className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28">
      <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <p className="eyebrow">
            <span className="h-px w-10 bg-brand-500" />
            Catálogo
          </p>
          <h2 className="mt-4 font-display text-4xl font-medium text-ink md:text-5xl">
            Explorá por categoría
          </h2>
        </div>
        <p className="max-w-sm text-sm font-light text-ink-500">
          Encontrá la luminaria ideal según el ambiente y la aplicación de tu
          proyecto.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6 lg:grid-cols-5">
        {c.data &&
          c.data[0].map((cat, i) => (
            <Category key={cat.id} data={cat} index={i} />
          ))}
        <Category
          index={99}
          data={{ nombre: 'Ver todas', id: 3, imagen: 'todas.jpg' }}
        />
      </div>
    </section>
  );
}

export default Categories;
